import { useMemo } from 'react';
import { TableFilterSelectOption } from '../../components/table-filter-select';
import { useExportsMetadataStore } from '../../store/exports-metadata';
import { ExportSearchGrouping } from '../types';

export function useAddExportsGroupingMetadata(
  options: TableFilterSelectOption[]
) {
  const { metadata } = useExportsMetadataStore();

  return useMemo(
    () =>
      options.map((o) => ({
        ...o,
        metadata:
          metadata &&
          (o.value !== 'All Types'
            ? metadata[o.key as ExportSearchGrouping]
            : metadata[ExportSearchGrouping.COMPANY] +
              metadata[ExportSearchGrouping.PERSON]),
      })),
    [metadata]
  );
}
